import { Action, ActionType } from "./actions";
import { StateContext } from "./store";

export const reducer = (state: StateContext, action: Action) => {
  switch (action.type) {
    case ActionType.SetMedication:
      return { ...state, medication: action.payload };
    case ActionType.SetAdministration:
      return { ...state, administration: action.payload };
    case ActionType.AddError:
      if(Array.isArray(action.payload))
      {
          return { ...state, errors: action.payload };
      }
      else{
          return { ...state, errors: [action.payload, ...state.errors] };
      }
    case ActionType.ResetErrors:
      return { ...state, errors: [] };
    default:
      throw new Error("Not among actions");
  }
};
